import React from 'react'

export default function Notice({children}) {
    return (
        <div style={{ 'textAlign': 'center', 'marginBottom': '0.7em' }}><strong>{children}</strong></div>
    )
}
